import { tokens } from '@kdk/shared/theme';
import { Box, Button, Drawer } from '@mui/material';
import type { ReactNode } from 'react';

/** 「← 案件 C01 に戻る」。別のドロワーの中から開いたとき、ヘッダー行の左に出す。 */
export type BackLink = { label: string; onClick: () => void };

type Props = {
  title: string;
  onClose: () => void;
  /**
   * true なら下の余白を 0 にする。内容の末尾に position: sticky のフッターを置く編集ドロワー用
   * (余白があると、フッターがその分だけ浮いて、下に内容が見えてしまう)。
   */
  flushBottom?: boolean;
  /** あれば、ヘッダー行の左に「戻る」ボタンを出す(右の「閉じる」は変わらない)。 */
  back?: BackLink | undefined;
  children: ReactNode;
};

export const DetailDrawer = ({ title, onClose, flushBottom = false, back, children }: Props) => (
  <Drawer
    anchor="right"
    open
    onClose={onClose}
    slotProps={{
      paper: {
        role: 'dialog',
        'aria-label': title,
        sx: {
          width: 'min(640px, 100%)',
          bgcolor: tokens.drawer,
          borderLeft: `1px solid ${tokens.line2}`,
          px: '24px',
          pt: 'calc(22px + env(safe-area-inset-top, 0px))',
          pb: flushBottom ? 0 : 'calc(40px + env(safe-area-inset-bottom, 0px))',
        },
      },
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
      {back === undefined ? (
        <span />
      ) : (
        <Button
          onClick={back.onClick}
          variant="text"
          size="small"
          sx={{
            color: 'text.secondary',
            minWidth: 0,
            // 狭い画面でも「閉じる」を押し出さない(長いときは省略する)
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            justifyContent: 'flex-start',
          }}
        >
          {back.label}
        </Button>
      )}
      <Button
        onClick={onClose}
        variant="outlined"
        size="small"
        sx={{ flex: 'none', color: 'text.secondary', borderColor: tokens.line2 }}
      >
        閉じる
      </Button>
    </Box>
    {children}
  </Drawer>
);
